import { setupCountdown } from './header/countdown'

export const setupHeader = (): void => {
  const header = document.querySelector('.js-header')
  const countdownEl = header?.querySelector<HTMLElement>('.js-deal__countdown')
  if (countdownEl) {
    setupCountdown(countdownEl)
  }
}
